import { defineNuxtPlugin } from '@nuxtjs/composition-api';

export default defineNuxtPlugin(({ app: { store } }, inject) => {
  const isPresent = (tooltip: string) => {
    return store?.$auth.loggedIn && store.$auth.user?.tooltips?.includes(tooltip);
  };

  const close = async (tooltip: string) => {
    if (isPresent(tooltip) || !store?.$auth.user?.tooltips) return;

    const user = {
      ...store.$auth.user,
      tooltips: [...store.$auth.user.tooltips, tooltip],
    };

    store.$auth.$storage.setState('user', user);
    await store.$api.$get(`/profile/tooltips/complete.json?task=${tooltip}`);
  };

  inject('tooltip', { close, isPresent });
});
